/**
 * Created by A665445 on 13/04/2017.
 */
import {TmmsaisineSharedModule} from '../shared/shared.module';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {InternalComponent} from './internal.component';
import {INTERNAL_ROUTE} from './internal.route';
import {RouterModule} from '@angular/router';

@NgModule({
    imports: [
        TmmsaisineSharedModule,
        RouterModule.forRoot([ INTERNAL_ROUTE ], { useHash: true })
    ],
    declarations: [
        InternalComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TmmsaisineInternalModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/internal/internal.module.ts